import request from 'utils/request';
import { baseAuthApiUrl } from '../constants';

export function login(data: any) {
    return request({
        url: '/sign-in',
        method: 'post',
        data: data,
        baseURL: baseAuthApiUrl,
    });
}
